<template>
  <a-modal
        :maskClosable="false"
          title="合伙人结算配置"
          :width="1000"
          :style="{'top':'10px'}"
          :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
          v-model="visibleModel"
          @cancel="handleCancel"
          @ok="handleOk"
  >
    <a-spin :spinning="saveLoading">
      <a-form :form="form">

        <a-form-item
                label="是否开启结算功能"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
        >
          <r-switch :formData="formData" field="open_partner_cash" :checkedValue="1" :unCheckedValue="2" checkedChildren="开启" unCheckedChildren="关闭" />
        </a-form-item>

        <a-form-item
                v-show="formData.open_partner_cash==1"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="规则配置"
                hasFeedback
        >
          <a-radio-group v-model="formData.partner_cash_setting_mode" buttonStyle="solid">
            <a-radio-button :value="1">以全局配置为准</a-radio-button>
            <a-radio-button :value="2">该商品单独配置</a-radio-button>
          </a-radio-group>
        </a-form-item>


        <div v-show="formData.partner_cash_setting_mode==2">

          <a-form-item
                  v-show="formData.open_partner_cash==1"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="奖励模式"
                  hasFeedback
          >
            <a-radio-group v-model="formData.partner_cash_mode" buttonStyle="solid">
              <a-radio-button :value="1">统一设置</a-radio-button>
              <a-radio-button :value="2">按用户组设置</a-radio-button>
            </a-radio-group>


            <a-select
                    v-if="formData.partner_cash_mode==2&&formData.partner_cash_goods_mode==2"
                      placeholder="请先配置销售用户组"
                    v-model="sellerGroupSelectValue"
                      style="width: 200px; margin-left: 10px;" >
              <a-select-option :value="option.id" :key="option.id" v-for="option in formData.partnerGroupCashList">{{option.name}}</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item
                  v-show="formData.open_partner_cash==1"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="商品模式"
                  hasFeedback
          >
            <a-radio-group v-model="formData.partner_cash_goods_mode" buttonStyle="solid">
              <a-radio-button :value="1">按商品整体配置</a-radio-button>
              <a-radio-button :value="2">按每个sku配置</a-radio-button>
            </a-radio-group>
          </a-form-item>


          <a-form-item
                  v-show="formData.open_partner_cash==1&& formData.partner_cash_mode==1&&formData.partner_cash_goods_mode==1"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="合伙人结算价"
                  hasFeedback
                  extra="合伙人结算价=商品原金额的千分之几"
          >
            <a-input type="number" v-decorator="[
          'partner_cash_percent',
          {rules: [{ required: true, message: '请输入比例' }]}
        ]"
                     placeholder="请输入比例"/>
          </a-form-item>
<!--          <a-form-item-->
<!--                  v-show="formData.open_partner_cash==1&& formData.partner_cash_mode==1&&formData.partner_cash_goods_mode==1"-->
<!--                  :labelCol="labelCol"-->
<!--                  :wrapperCol="wrapperCol"-->
<!--                  label="团长提成"-->
<!--                  hasFeedback-->
<!--                  extra="团长提成=完成订单实际支付商品金额的千分之几"-->
<!--          >-->
<!--            <a-input type="number" v-decorator="[-->
<!--          'team_reward_percent',-->
<!--          {rules: [{ required: true, message: '请输入比例' }]}-->
<!--        ]"-->
<!--                     placeholder="请输入比例"/>-->
<!--          </a-form-item>-->

          <a-table
                  v-show="formData.open_partner_cash==1&& formData.partner_cash_mode==2&&formData.partner_cash_goods_mode==1"
                  :columns="sellerGroupColumns" :dataSource="formData.partnerGroupCashList" :locale="{emptyText:'请先配置合伙人价格体系'}" :pagination="false" rowKey="id"  bordered>
            <template slot="sellerPercent" slot-scope="text,record,index">
              <a-input type="number"  v-model="record.partner_percent" placeholder="千分之几"/>
            </template>
<!--            <template slot="teamPercent" slot-scope="text,record,index">-->
<!--              <a-input type="number" v-model="record.team_percent" placeholder="千分之几"/>-->
<!--            </template>-->
            <template slot="sellerPercentTitle">
              合伙人结算比例
              <a-popover content="请设置千分之几">
                <a-icon type="question-circle" />
              </a-popover>
            </template>
<!--            <template slot="teamPercentTitle">-->
<!--              团长提成比例-->
<!--              <a-popover content="请设置千分之几">-->
<!--                <a-icon type="question-circle" />-->
<!--              </a-popover>-->
<!--            </template>-->
          </a-table>

          <a-table
                  v-show="formData.open_partner_cash==1&&formData.partner_cash_goods_mode==2 && skuTable.sku_list.length"
                  :columns="skuColumns"  :dataSource="skuTable.sku_list" :pagination="false" rowKey="key"  bordered>
            <template slot="sellerReward">
              <a-popconfirm okText="确定" cancelText="取消" @confirm="setAllSellerReward">
                <span slot="icon" />
                <template slot="title">
                  <PriceInput
                          :formData="setAll"
                          field="setAllSellerRewardValue"
                          placeholder="批量设置合伙人结算"/>
                  <!--<a-input-->
                          <!--v-model="setAllSellerRewardValue"-->
                          <!--placeholder="批量设置销售提成" />-->
                </template>
                合伙人结算 <a-icon type="form" />
              </a-popconfirm>
            </template>

<!--            <template slot="teamReward">-->
<!--              <a-popconfirm okText="确定" cancelText="取消" @confirm="setAllTeamReward">-->
<!--                <span slot="icon" />-->
<!--                <template slot="title">-->
<!--                  <PriceInput-->
<!--                              :formData="setAll"-->
<!--                              field="setAllTeamRewardValue"-->
<!--                              placeholder="批量设置团长提成"/>-->
<!--                  &lt;!&ndash;<a-input&ndash;&gt;-->
<!--                          &lt;!&ndash;v-model="setAllTeamRewardValue"&ndash;&gt;-->
<!--                          &lt;!&ndash;placeholder="批量设置团长提成" />&ndash;&gt;-->
<!--                </template>-->
<!--                团长提成 <a-icon type="form" />-->
<!--              </a-popconfirm>-->
<!--            </template>-->


            <template slot="id" slot-scope="text,record,index">
              <a-input v-model="record.id" placeholder="id"/>
            </template>
            <template slot="partner_reward" slot-scope="text,record,index">
              <PriceInput v-show="formData.partner_cash_mode==1"
                          :formData="record"
                          field="partner_reward"
                          placeholder="结算价(元)"/>

              <PriceInput v-show="formData.partner_cash_mode==2"
                          :formData="record.partner_cash_rule"
                          :field="sellerGroupSelectValue"
                          placeholder="结算价(元)"/>
              <!--<a-input v-show="formData.partner_cash_mode==1" v-model="record.partner_reward" placeholder="结算价(元)"/>-->
              <!--<a-input v-show="formData.partner_cash_mode==2" v-model="record.partner_cash_rule[sellerGroupSelectValue]" placeholder="结算价(元)"/>-->
            </template>
<!--            <template slot="team_reward" slot-scope="text,record,index">-->
<!--              <PriceInput v-show="formData.partner_cash_mode==1"-->
<!--                          :formData="record"-->
<!--                          field="team_reward"-->
<!--                          placeholder="结算价(元)"/>-->

<!--              <PriceInput v-show="formData.partner_cash_mode==2"-->
<!--                          :formData="record.team_reward_rule"-->
<!--                          :field="sellerGroupSelectValue"-->
<!--                          placeholder="结算价(元)"/>-->
<!--              &lt;!&ndash;<a-input v-show="formData.partner_cash_mode==1" v-model="record.team_reward" placeholder="结算价(元)"/>&ndash;&gt;-->
<!--              &lt;!&ndash;<a-input v-show="formData.partner_cash_mode==2" v-model="record.team_reward_rule[sellerGroupSelectValue]" placeholder="结算价(元)"/>&ndash;&gt;-->
<!--            </template>-->
          </a-table>

        </div>


      </a-form>

    </a-spin>
    <template slot="footer">
      <a-button key="cancel" @click="handleCancel">取消</a-button>
      <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
    </template>
  </a-modal>
</template>

<script>
  import RSwitch from '@/components/RSwitch/'
  import { getPartnerCashSetting,partnerCashSetting } from '@/api/goods'
  import PriceInput from '@/components/PriceInput/'

  export default {
    name: 'GoodsPartnerCashForm',
    components: {
      RSwitch,
      PriceInput,
    },
    props: {
      goodsId:{
        type: String|Number,
        required: true
      },
      visible:{
        type: Boolean,
        default:false
      }
    },
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        goods:{
          id:this.$route.query.id
        },
        saveLoading:false,
        setAll:{
          setAllSellerRewardValue:'',
          setAllTeamRewardValue:'',
        },
        formData:{
          goods_id:0,
          open_partner_cash:1,
          partner_cash_setting_mode:1,
          partner_cash_mode:1,
          partner_cash_goods_mode:1,
          partnerGroupCashList:[],
          sku:[],
          sku_list:[]
        },
        sellerGroupSelectValue:undefined,
        sku_fields_list:[],
        setAllPriceValue:'',
        skuTable:{
          sku_fields_sets:[],
          sku_list:[],
        },
        //表头
        sellerGroupColumns: [
          {
            title: '用户组',
            width:'100px',
            dataIndex: 'name',
          },
          {
            width:'100px',
            dataIndex: 'seller_percent',
            slots: { title: 'sellerPercentTitle' },
            scopedSlots: { customRender: 'sellerPercent' },
          },
          // {
          //   width:'100px',
          //   dataIndex: 'team_percent',
          //   slots: { title: 'teamPercentTitle' },
          //   scopedSlots: { customRender: 'teamPercent' },
          // },
        ],
      }
    },
    watch: {
      goodsId(value){
        let that = this
        if(value){
          that.getPartnerCashSetting();
        }
      }
    },
    methods: {
      priceChange(data){
        console.log(data)
      },
      sellerRewardChange(data,item){
        console.log(data,item)
        console.log(this.skuTable.sku_list)

      },
      setAllSellerReward(){
        let that = this;
        that.skuTable.sku_list.map(item =>{
          if(that.formData.partner_cash_mode==1){
            // console.log(item.partner_reward)
            item.partner_reward = that.setAll.setAllSellerRewardValue;
          }else{
            item.partner_cash_rule[that.sellerGroupSelectValue] = that.setAll.setAllSellerRewardValue;
            console.log(item,that.sellerGroupSelectValue)
          }
        });
        // that.setAll.setAllSellerRewardValue = undefined;
      },
      setAllTeamReward(){
        let that = this;
        that.skuTable.sku_list.map(item =>{
          if(that.formData.partner_cash_mode==1){
            item.team_reward = that.setAll.setAllTeamRewardValue;
          }else{
            // item.team_reward_rule[that.sellerGroupSelectValue] = that.setAll.setAllTeamRewardValue;
            console.log(item.team_reward_rule,that.sellerGroupSelectValue)

          }
        });
        // that.setAll.setAllTeamRewardValue = undefined;
      },
      handleOk(e){
        let self = this
        e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
//            self.saveLoading = true;
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.formData)
            self.formData.goods_id = self.goodsId;
            self.formData.sku_list = JSON.stringify(self.skuTable.sku_list)
            // self.formData.sku_list = self.skuTable.sku_list

            partnerCashSetting(Object.assign(self.formData,values)).then(res => {
              self.$message.success('设置成功')
              self.saveLoading = false;
              this.$emit('sellerRewardDone')
            }).catch(err =>{
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }else{
            console.log(err);
          }
        })
      },
      handleCancel(){
        this.$emit('sellerRewardDone')
      },

      getPartnerCashSetting(){
        let that = this
        getPartnerCashSetting({ goods_id: that.goodsId }).then(res => {
          that.formData = res.data;
          that.form.setFieldsValue({...res.data});
          that.formData.sku = res.data.sku;
          that.sku_fields_list = res.data.sku_fields_list;
          if(that.formData.partnerGroupCashList.length>0){
            that.sellerGroupSelectValue = that.formData.partnerGroupCashList[0].id;
          }
          that.refreshSkuList();
        })
        // .catch(err =>{
        //   that.$message.error(err.data.msg)
        // })
      },

      refreshSkuList(){
        let self = this;
        var sets = [];
        var skulist = [];
        var count = [];
        if(this.sku_fields_list.length==0 || this.sku_fields_list[0].attrs.length==0){
          return {
            'sku_fields_sets' : sets,
            'sku_list' : skulist,
          }
        }
        for(var i = this.sku_fields_list.length-1 ; i >=0 ; i-- ){
          var key = this.sku_fields_list.length-1-i;
          var rkey = i;
          var list = [];
          var len = this.sku_fields_list[i].attrs.length;
          if(i-1>=0){
            count[i-1] = len * ( count[i] ? count[i] : 1);
          }

          sets[key] = [];
          if (key == 0) {
            for(var l = 0 ; l<this.sku_fields_list[key].attrs.length ; l++ ){
              sets[key].push({
                'id' : this.sku_fields_list[key].attrs[l].id,
                'title' : this.sku_fields_list[key].attrs[l].title,
                'sku' : [{
                  'field_id': this.sku_fields_list[key].id,
                  'attr_id': this.sku_fields_list[key].attrs[l].id,
                  'attr_title': this.sku_fields_list[key].attrs[l].title,
                }]
              })
            }
          } else {
            var ccount =  sets[key-1].length;
//                        console.log('ccount');
//                        console.log(ccount);
            for(var n = 0; n < ccount ; n++) {
              for(var j= 0; j <  this.sku_fields_list[key].attrs.length ; j++){
                var sku = sets[key-1][n]['sku'];
                sets[key].push(
                        {
                          'id' : this.sku_fields_list[key].attrs[j].id,
                          'title' : this.sku_fields_list[key].attrs[j].title,
                          'sku' : sku.concat({
                            'field_id': this.sku_fields_list[key].id,
                            'attr_id': this.sku_fields_list[key].attrs[j].id,
                            'attr_title': this.sku_fields_list[key].attrs[j].title,
                          })
                        }
                )
              }
//                            sets[key] = sets[key].concat(this.sku_fields_list[key].attrs);
            }
//                        console.log('set');
//                        console.log(sets[key]);
          }
        }

        for( var k = 0 ; k < sets.length ; k++){
          for(var index = 0 ; index < sets[k].length ;  index++){
            sets[k][index].height = count[k] ? count[k] : 1;
          }
        }
        if(sets[sets.length-1].length==0){
          sets.splice(sets.length-1,1);
        }

        let partner_cash_rule_Arr=[]
        let team_reward_rule_Arr=[]

        for(var p = 0 ; p < this.formData.sku.length ; p ++){
          let partner_cash_rule= {}
            let team_reward_rule={}
          this.formData.partnerGroupCashList.map((item,index)=>{
            // console.log(index,this.formData.sku[p].partner_cash_rule,this.formData.sku[p].partner_cash_rule[item.id])
            partner_cash_rule[item.id]=this.formData.sku[p].partner_cash_rule[item.id]
            // team_reward_rule[item.id]=this.formData.sku[p].team_reward_rule[item.id]
        })
         partner_cash_rule_Arr.push(partner_cash_rule)
            // team_reward_rule_Arr.push(team_reward_rule)
        }
        console.log(partner_cash_rule_Arr)
        for(var m=0; m< sets[sets.length-1].length ; m++){
          var row = {
            'key' : 'm'+m,
            'id' : 0,
            'code' : '',
            'price' : 0,
            'partner_cash_rule' : partner_cash_rule_Arr[m],
            // 'team_reward_rule' : team_reward_rule_Arr[m],
            'partner_reward' : 0,
            'team_reward' : 0,
            'cost_price' : 0,
            'sold_count' : 0,
            'unit_count' : 1,
            'stock' : 0,
            'popoverVisible' : false,
            'sku' : sets[sets.length-1][m].sku,
            'height' : sets[sets.length-1][m].height
          };
          for(var p = 0 ; p < this.formData.sku.length ; p ++){
            let skuArray = [];
            sets[sets.length-1][m].sku.map(skuItem =>{
              skuArray.push({
                field_id: skuItem.field_id,
                attr_id: skuItem.attr_id,
              })
            });
            console.log('skuArray');
            console.log(skuArray);
            if(JSON.stringify(this.formData.sku[p].sku).replace(/"/g,'') == JSON.stringify(skuArray).replace(/"/g,'')){
              let partner_cash_rule=[]
              let team_reward_rule=[]
              if(this.formData.sku[p].partner_cash_rule.length>0){
                partner_cash_rule=this.formData.sku[p].partner_cash_rule
              }else{
                partner_cash_rule=row.partner_cash_rule
              }
              // if(this.formData.sku[p].team_reward_rule.length>0){
              //   team_reward_rule=this.formData.sku[p].team_reward_rule
              // }else{
              //   team_reward_rule=row.team_reward_rule
              // }
              row = {
                'key':'p'+p,
                'id' : this.formData.sku[p].id,
                'code' : this.formData.sku[p].code,
                'price' : this.formData.sku[p].price,
                'cost_price' : this.formData.sku[p].cost_price,
                'sold_count' : this.formData.sku[p].sold_count,
                'unit_count' : this.formData.sku[p].unit_count,
                'partner_cash_rule' : partner_cash_rule,
                // 'team_reward_rule' : team_reward_rule,
                'partner_reward' : this.formData.sku[p].partner_reward,
                'team_reward' : this.formData.sku[p].team_reward,
                'stock' : this.formData.sku[p].stock,
                'popoverVisible' : false,
                'sku' : sets[sets.length-1][m].sku,
                'height' : sets[sets.length-1][m].height
              };

              console.log(this.formData.sku)
              break ;
            }
          }
          skulist.push(row);
        }
        console.log('skulist')
        console.log(skulist)
        self.skuTable = {
          sku_fields_sets:sets,
          sku_list:skulist,
        }
      },
    },
    computed:{
      visibleModel:{
        get: function () {
          return this.visible;
        },
        set: function () {
        }
      },
      skuColumns(){
        let self = this;
        let skuColums = [];
        self.sku_fields_list.map((item,index) =>{
          if(item.attrs.length ==0){
            return;
          }
          skuColums.push({
            title: ''+item.title,
            width: 100,
            dataIndex: 'sku['+index+'].attr_title',
            customRender: (value, row, index2) => {
              const obj = {
                children: value,
                attrs: {},
              };
              let rowSpan = self.skuTable.sku_fields_sets[index][0].height;
              if(index2 % rowSpan ==0){
                obj.attrs.rowSpan = rowSpan;
              }else{
                obj.attrs.rowSpan = 0;
              }
              return obj;
            }
          });
        });
        let constColums =  [
          {
            width: 100,
            dataIndex: 'price',
            title:'原价',
            customRender: (text) =>  {
              return parseFloat(text).toFixed(2);
            }
          },
          {
            width: 100,
            dataIndex: 'partner_reward',
            slots: { title: 'sellerReward' },
            scopedSlots: { customRender: 'partner_reward' }
          },
          // {
          //   width: 100,
          //   dataIndex: 'team_reward',
          //   slots: { title: 'teamReward' },
          //   scopedSlots: { customRender: 'team_reward' }
          // },
          {
            width: 100,
            title:'成本',
            dataIndex: 'cost_price',
            customRender: (text) =>  {
              return parseFloat(text).toFixed(2);
            }
          },
        ];
        return skuColums.concat(constColums);
      }
    },
  }
</script>

<style lang="less" scoped>
</style>
